import { render, staticRenderFns } from "./userTransactions.vue?vue&type=template&id=e17984b6&scoped=true&"
import script from "./userTransactions.vue?vue&type=script&lang=ts&"
export * from "./userTransactions.vue?vue&type=script&lang=ts&"
import style0 from "./userTransactions.vue?vue&type=style&index=0&id=e17984b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17984b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})
